import PropTypes from "prop-types";
import {
    Input,
    Text,
} from "./InputLayer.styles";
const PLACEHOLDER_VALUE = "--";

const InputLayer = ({
    onChange,
    value,
    editable,
    color,
    onUpdate,
    onFocus,
    ...props
}) => {
    
    const handleKeyDown = (event) => {
        const allowedValues = /^(\s*|\d+)$/;
        !event.target.value.match(allowedValues) && event.preventDefault();
    };

    const handleChange = (event) => {
        onChange(event);
    }
    
    const handleFocus = (event) => {
        onFocus(event);
        event.target.select();
    }
    
    const handleBlur = (event) => {
        onUpdate(event);
    }

    return (
        <div className={props.className}>
                {editable ? (
                    <Input
                        type="number"
                        $color={color}
                        value={value}
                        onKeyDown={handleKeyDown}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        placeholder={PLACEHOLDER_VALUE}
                        autoFocus
                        data-tabindex={props.tabIndex}
                        data-projectid={props.projectId}
                    />
                ) : (
                    <Text>{value || PLACEHOLDER_VALUE}</Text>
                )}
        </div>
    );
};

InputLayer.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    editable: PropTypes.bool,
    color: PropTypes.string,
    onUpdate: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    className: PropTypes.string,
    tabIndex: PropTypes.number,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InputLayer;
